"use client";

import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import { useFieldControl } from "@/components/ui/field-control";

const textareaVariants = cva(
  "flex min-h-15 w-full rounded-field border border-input bg-card px-3 py-2 text-base text-foreground placeholder:text-fg-subtle outline-none focus-visible:border-ring focus-visible:ring-[2px] focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:bg-surface-2 disabled:text-fg-subtle aria-invalid:border-destructive aria-invalid:ring-destructive/20 max-md:text-base md:text-sm",
  {
    variants: {
      variant: {
        default: "",
        mono: "tabular-nums",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Textarea(
  textareaProps: React.ComponentProps<"textarea"> &
    VariantProps<typeof textareaVariants>,
) {
  const { className, variant, ...props } = useFieldControl(textareaProps);
  return (
    <textarea
      data-slot="textarea"
      className={cn(textareaVariants({ variant, className }))}
      {...props}
    />
  );
}

export { Textarea, textareaVariants };
